import { render } from "./profile-files.svg?vue&type=template&id=75730ea5"
const script = {}
script.render = render

export default script